import { render, staticRenderFns } from "./ticket-page.vue?vue&type=template&id=27c58972&scoped=true&"
import script from "./ticket-page.vue?vue&type=script&lang=js&"
export * from "./ticket-page.vue?vue&type=script&lang=js&"
import style0 from "./ticket-page.vue?vue&type=style&index=0&id=27c58972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c58972",
  null
  
)

export default component.exports